export const MapsReducer = (state, action) => {
  switch (action.type) {
    case "SETUP_INITIAL_MAP":
      return {
        ...state,
        viewport: {
          center: action.center,
          zoom: action.zoom,
        },
        data: action.data,
      };
    case "GET_MAP_DATA":
      const data = action.results.features.map((element) => {
        const {
          title,
          date: fullDate,
          category: categoryObj,
          slug,
        } = element.properties;
        const date = fullDate.substring(0, 10);
        const catSlug = categoryObj.slug;
        const geolocation = element.geometry.coordinates.reverse();

        return { title, date, catSlug, slug, geolocation };
      });

      return {
        ...state,
        count: action.count,
        next: action.next,
        previous: action.previous,
        viewport: {
          ...state.viewport,
          center: action.center,
          zoom: action.zoom,
        },
        data: [...state.data, ...data],
      };
    case "CLEAR_MAP_DATA":
      return {
        ...state,
        count: 0,
        next: null,
        previous: null,
        results: [],
      };
    default:
      return state;
  }
};
